<template>
<section v-if="!init" class="h-screen"></section>
<template v-else>
    <template v-if="showTabs">
        <h4 class="text-left px-3 my-2 text-base text-gray-600 dark:text-white/75 font-semibold">
            {{ stats.localization['trade_statistics_available_bots_title'].slice(0, -2) }}
        </h4>
        
        <section class="min-h-screen">
            <n-tabs
                type="line"
                size="small"
                class="marketplace-n-tab"
                :value="currentTab"
                @update:value="changeTab">
                <n-tab-pane
                    v-for="(tab, i) in tabs"
                    :key="i"
                    :name="tab.name"
                    :disabled="loading">
                    <template #tab>
                        <div class="flex items-center">
                            {{ tab.title }}
                            <n-tag size="tiny" v-if="tab.name === 'transactions'" round type="warning" :bordered="false" class="ml-2">
                                <strong class="text-[8px]">NEW</strong>
                            </n-tag>
                        </div>
                    </template>
                    <router-view></router-view>
                </n-tab-pane>
            </n-tabs>
        </section>
    </template>
    <router-view v-else></router-view>
</template>
</template>
    
<script>
// general
import general from './general';

// store
import { useStats } from '@store/stats';
import { useGl } from '@store/ts/gl';
    
// i18n
import { useI18n } from 'vue-i18n';

// UI
import {
    NTag,
    NCard,
    NTabs,
    NTabPane } from 'naive-ui';
    
export default {
    name: 'trade-statistic-desktop',
    components: {
        NTag,
        NCard,
        NTabs,
        NTabPane,
    },
    setup(props, context) {
        // store
        const gl = useGl();
        const stats = useStats();

        // i18n
        const { t } = useI18n();
    
        return {
            gl,
            stats,
            ...general(props, context),
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(.n-tabs) {

  // .n-tabs-nav {
  //   position: sticky;
  //   top: 56px;
  //   z-index: 100;
  //   background: red;
  // }
  .n-tabs-wrapper  {
    padding: 0 12px;
  }
  .n-tabs-tab .n-tabs-tab__label {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }
}

:deep(.n-tabs-bar) {
  left: 0;
}
</style>